import ExportImage from "../../../images/Export.svg";
import "./pictureDisplaySelector.scss";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import React, { useRef } from "react";

function PictureDisplaySelector({
  onImageChange,
  imageUrl,
  error,
  onGenerateAiIcon,
  aiIconLoading,
  aiIconDisabled,
  aiIconStatus,
}) {
  const { t } = useTranslation("pictureDisplaySelector");
  const fileInputRef = useRef(null); // Create a reference for the file input

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const img = new Image();
        img.src = reader.result;
        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
          const MAX_WIDTH = 1200;
          const MAX_HEIGHT = 500;
          let width = img.width;
          let height = img.height;

          if (width > height) {
            if (width > MAX_WIDTH) {
              height *= MAX_WIDTH / width;
              width = MAX_WIDTH;
            }
          } else {
            if (height > MAX_HEIGHT) {
              width *= MAX_HEIGHT / height;
              height = MAX_HEIGHT;
            }
          }

          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0, width, height);
          canvas.toBlob((blob) => {
            const newImageUrl = URL.createObjectURL(blob);
            onImageChange({ target: { files: [blob], name: file.name } });
            fileInputRef.current.value = ""; // Clear the input value
          }, "image/jpeg");
        };
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <>
      <section
        className={`imageContainer ${onGenerateAiIcon ? "hasAiAction" : ""} ${
          error ? "errorInput" : ""
        }`}
      >
        {imageUrl ? (
          <div className="imageWrapper">
            <img src={imageUrl} className="picture" />
          </div>
        ) : (
          <h4>{t("noImageYet")}</h4>
        )}

        <input
          type="file"
          id="fileUpload"
          style={{ display: "none" }}
          onChange={handleImageChange}
          ref={fileInputRef} // Attach the ref to the input
        />
        <div className="imageActions">
          <button
            onClick={() => fileInputRef.current?.click()}
            className="imageUploadButton"
            type="button"
          >
            <img src={ExportImage} />
            <p>{t("uploadImage")}</p>
          </button>
          {onGenerateAiIcon && (
            <button
              className="imageAiButton"
              type="button"
              onClick={onGenerateAiIcon}
              disabled={aiIconLoading || aiIconDisabled}
            >
              <span aria-hidden="true">✨</span>
              <p>{aiIconLoading ? t("aiIconGenerating") : t("generateAiIcon")}</p>
            </button>
          )}
        </div>
        {aiIconStatus && <span className="imageAiStatus">{aiIconStatus}</span>}
      </section>
      {error && <p className="errorMessage">{error}</p>}
    </>
  );
}

PictureDisplaySelector.propTypes = {
  onImageChange: PropTypes.func.isRequired,
  imageUrl: PropTypes.string,
  error: PropTypes.string,
  onGenerateAiIcon: PropTypes.func,
  aiIconLoading: PropTypes.bool,
  aiIconDisabled: PropTypes.bool,
  aiIconStatus: PropTypes.string,
};

export default PictureDisplaySelector;
